import {RestAPI} from '@/constants/routeAPI';

import axiosMethods from './apiManager';

// eslint-disable-next-line import/prefer-default-export
export const getIsAvailableWifi = async (isCatchHandled = false) => {
  const response = await axiosMethods.get(RestAPI.IS_AVAILABLE_WIFI, null, true, isCatchHandled);
  return response;
};
